"use client"

import { motion } from "framer-motion"
import wave from "../assets/images/wave.png"

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      {/* Header Section with Wave */}
      <div className="relative bg-brand-navy">
        <div className="container mx-auto px-4 pt-8 sm:pt-16 pb-32 text-center text-white">
          <motion.h1
            className="font-outfit text-[28px] mt-10 sm:mt-10 sm:text-[35px] md:text-[42px] lg:text-[44.47px] mt-8 sm:mt-10 font-[400] leading-[36px] sm:leading-[46px] md:leading-[56.03px] text-center mb-6 z-10 relative text-white sm:text-white sm:bg-white sm:bg-clip-text break-words"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Privacy Policy
          </motion.h1>
          <motion.p
            className="text-whiet sm:text-white/90 z-10 relative text-sm sm:text-base mb-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Last Modified on: 06-March-2025
          </motion.p>
        </div>
        <div className="absolute bottom-[-18px] left-0 w-full hidden sm:block">
          <img
            src={wave}
            alt="wave"
            className="w-full"
          />
        </div>
        <div className="absolute bottom-[2rem] left-0 w-full sm:hidden">
          <img
            src={wave}
            alt="wave"
            className="w-full h-[13rem]"
          />
        </div>
      </div>

      {/* Content Section */}
      <div className="bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto space-y-8">
            <div className="space-y-4">
              <p className="text-gray-800">
                At EG to GO, we value your trust and are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our mobile application (the "App") and related services. Please read this policy carefully.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">1. Information We Collect</h2>
              <p className="text-gray-800">We collect the following types of information:</p>
              <div className="pl-4">
                <h3 className="font-medium text-gray-900">a. Personal Information:</h3>
                <ul className="space-y-2 text-gray-800 pl-4">
                  <li>• Name, email address, phone number, and payment details.</li>
                  <li>• Location data for booking and providing ride services.</li>
                </ul>
                <h3 className="font-medium text-gray-900 mt-2">b. Non-Personal Information:</h3>
                <ul className="space-y-2 text-gray-800 pl-4">
                  <li>• Device information (model, operating system, unique identifiers).</li>
                  <li>• App usage data, including search queries and browsing patterns.</li>
                </ul>
                <h3 className="font-medium text-gray-900 mt-2">c. Information from Service Providers:</h3>
                <ul className="space-y-2 text-gray-800 pl-4">
                  <li>• Ratings, feedback, and service history.</li>
                </ul>
              </div>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">2. How We Use Your Information</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• Facilitate and manage ride bookings.</li>
                <li>• Process payments securely.</li>
                <li>• Provide customer support.</li>
                <li>• Improve our App's functionality and user experience.</li>
                <li>• Ensure compliance with legal and regulatory requirements.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">3. Sharing Your Information</h2>
              <p className="text-gray-800">We may share your information with:</p>
              <ul className="space-y-2 text-gray-800">
                <li>• Drivers and service providers for fulfilling booking requests.</li>
                <li>• Payment processors for transaction purposes.</li>
                <li>• Legal authorities when required by law.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">4. Data Retention</h2>
              <p className="text-gray-800">
                We retain your data as long as necessary to provide services, comply with legal obligations, or resolve disputes.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">5. Your Rights</h2>
              <ul className="space-y-2 text-gray-800">
                <li>• Access, update, or delete your personal data.</li>
                <li>• Withdraw consent for data processing where applicable.</li>
              </ul>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">6. Security</h2>
              <p className="text-gray-800">
                We implement industry-standard measures to protect your data but cannot guarantee absolute security.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">7. Changes to This Policy</h2>
              <p className="text-gray-800">
                We may update this Privacy Policy from time to time. Changes will be posted in the App with a revised "Effective Date."
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">Contact Information</h2>
              <p className="text-gray-800">
                For questions or concerns, contact us at:<br />
                Email: support@egtogo.com<br />
                Phone: +91 9955210717
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
